module.exports = __webpack_public_path__ + "img/Header-Option-discord.ef92ef0c.jpg";